import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import UrlParse from 'url-parse';
import { mapGetters } from 'vuex';

var GlobalTitle = function GlobalTitle() {
  return import(
  /* webpackChunkName:"global-editorial" */
  '~/components/atoms/Editorial/Global/GlobalTitle.vue');
};

var ProductItem = function ProductItem() {
  return import(
  /* webpackChunkName: "product" */
  '~/components/library/Product/ProductItem.vue');
};

export default {
  name: 'ArticleProducts',
  components: {
    GlobalTitle: GlobalTitle,
    ProductItem: ProductItem
  },
  props: {
    payload: {
      type: Object,
      required: true
    },
    catalog: {
      type: Object,
      required: true
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    currentPayload: function currentPayload() {
      var _ref, _ref2, _ref3, _ref4;

      return {
        title: ((_ref4 = this.payload) != null ? (_ref4 = _ref4.primary) != null ? (_ref4 = _ref4.title) != null ? _ref4[0] : _ref4 : _ref4 : _ref4) || {},
        subtitle: ((_ref3 = this.payload) != null ? (_ref3 = _ref3.primary) != null ? (_ref3 = _ref3.subtitle) != null ? _ref3[0] : _ref3 : _ref3 : _ref3) || {},
        button: {
          text: ((_ref2 = this.payload) != null ? (_ref2 = _ref2.primary) != null ? _ref2.button_text : _ref2 : _ref2) || '',
          url: new UrlParse(((_ref = this.payload) != null ? (_ref = _ref.primary) != null ? (_ref = _ref.button_url) != null ? (_ref = _ref.link_type) != null ? _ref.url : _ref : _ref : _ref : _ref) || '').pathname
        }
      };
    }
  })
};